import {
    GET_GCP_ALERTS,
    GET_GCP_ALERTS_FAIL,
    GET_GCP_ALERTS_SUCCESS,
    GET_GCP_RESOURCE_BY_RESOURCE_ID,
    GET_GCP_RESOURCE_BY_RESOURCE_ID_SUCCESS,
    GET_GCP_RESOURCE_BY_RESOURCE_ID_FAIL,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_FAIL,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    POST_DISABLE_GCP_ALERTS,
    POST_DISABLE_GCP_ALERTS_FAIL,
    POST_DISABLE_GCP_ALERTS_SUCCESS,
    POST_ENABLE_GCP_ALERTS,
    POST_ENABLE_GCP_ALERTS_FAIL,
    POST_ENABLE_GCP_ALERTS_SUCCESS,
    PUT_GCP_ALERTS,
    PUT_GCP_ALERTS_FAIL,
    PUT_GCP_ALERTS_SUCCESS,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_FAIL,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    gcp_resource_missing_alerts: [],
    gcp_resource: {},
    default_threshold_gcp_resource: [],
    gcp_alerts: [],
    is_gcp_alerts_refreshing: false,
};

const GCPAlerts = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_GCP_ALERTS:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case GET_GCP_ALERTS_SUCCESS:
            return {
                ...state,
                gcp_alerts: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_GCP_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_GCP_RESOURCE_BY_RESOURCE_ID:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case GET_GCP_RESOURCE_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                gcp_resource: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_GCP_RESOURCE_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                default_threshold_gcp_resource: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS:
            return {
                ...state,
                gcp_resource_missing_alerts: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case POST_ENABLE_GCP_ALERTS:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case POST_ENABLE_GCP_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case POST_ENABLE_GCP_ALERTS_SUCCESS:
            return {
                ...state,
                gcp_alerts: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case POST_DISABLE_GCP_ALERTS:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case POST_DISABLE_GCP_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case POST_DISABLE_GCP_ALERTS_SUCCESS:
            return {
                ...state,
                gcp_alerts: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case PUT_GCP_ALERTS:
            return {
                ...state,
                is_gcp_alerts_refreshing: true,
            }

        case PUT_GCP_ALERTS_SUCCESS:
            Object.keys(state.gcp_alerts).forEach(key => {
                state.gcp_alerts[key].forEach(gcp_alert => {
                    if (gcp_alert.id === action.payload.id) {
                        gcp_alert = action.payload
                    }
                })
            })
            return {
                ...state,
                gcp_alerts: state.gcp_alerts,
                is_gcp_alerts_refreshing: false,
            }

        case PUT_GCP_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_alerts_refreshing: false,
            }

        case POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING:
            return {
                ...state,
                is_gcp_refreshing: true,
            }

        case POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS:
            action.payload.map((item) => {
                state.gcp_resource.application_service_id = item.application_service_id;
                state.gcp_resource.environment = item.environment;
                state.gcp_resource.deployment_stage = item.deployment_stage;
            });
            return {
                ...state,
                gcp_resource: state.gcp_resource,
                is_gcp_refreshing: false,
            }

        case POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_refreshing: false,
            }

        case POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS:
            return {
                ...state,
                is_gcp_refreshing: true
            }

        case POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_SUCCESS:
            return {
                ...state,
                gcp_alerts: action.payload,
                is_gcp_refreshing: false
            }

        case POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                is_gcp_refreshing: false
            }

        default:
            return state
    }
}

export default GCPAlerts;
